var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonetization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9e021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "monetization",
    d: "M23.95,38.35a1.261,1.261,0,0,0,.95-.425,1.382,1.382,0,0,0,.4-.975v-1.2a7.868,7.868,0,0,0,4.725-2.025A5.7,5.7,0,0,0,31.75,29.45a5.892,5.892,0,0,0-1.425-4.15A11.629,11.629,0,0,0,25.4,22.6a13.462,13.462,0,0,1-4.325-2.075A3.381,3.381,0,0,1,19.9,17.85a2.9,2.9,0,0,1,1.125-2.425A4.887,4.887,0,0,1,24.1,14.55a4.962,4.962,0,0,1,2.15.45,4.547,4.547,0,0,1,1.65,1.35,1.8,1.8,0,0,0,.85.55,1.182,1.182,0,0,0,.95-.1,1.276,1.276,0,0,0,.725-.8,1.031,1.031,0,0,0-.175-1,6.44,6.44,0,0,0-2.075-1.9,6.854,6.854,0,0,0-2.775-.85v-1.2A1.366,1.366,0,0,0,24.05,9.7a1.382,1.382,0,0,0-.975.4,1.261,1.261,0,0,0-.425.95v1.2a6.735,6.735,0,0,0-4.025,1.85,5.133,5.133,0,0,0-1.475,3.75,5.7,5.7,0,0,0,1.275,3.9A12.041,12.041,0,0,0,23.15,24.5a17.392,17.392,0,0,1,4.7,2.35A3.283,3.283,0,0,1,29,29.45a3.478,3.478,0,0,1-1.35,2.775,4.983,4.983,0,0,1-3.3,1.125,5.907,5.907,0,0,1-3.025-.8A5.429,5.429,0,0,1,19.2,30.3a1.742,1.742,0,0,0-.675-.625,1.073,1.073,0,0,0-.875-.075,1.457,1.457,0,0,0-.875.775A1.1,1.1,0,0,0,16.9,31.45a9.279,9.279,0,0,0,2.375,2.675A9.431,9.431,0,0,0,22.55,35.65V37a1.261,1.261,0,0,0,.425.95,1.382,1.382,0,0,0,.975.4ZM24,44a20.285,20.285,0,0,1-7.9-1.525A19.357,19.357,0,0,1,5.525,31.9,20.285,20.285,0,0,1,4,24a20.156,20.156,0,0,1,1.525-7.85A19.52,19.52,0,0,1,9.75,9.8,19.939,19.939,0,0,1,24,4,19.84,19.84,0,0,1,44,24a19.939,19.939,0,0,1-5.8,14.25,19.52,19.52,0,0,1-6.35,4.225A20.156,20.156,0,0,1,24,44ZM24,24Zm0,17A16.657,16.657,0,0,0,41,24,16.657,16.657,0,0,0,24,7,16.657,16.657,0,0,0,7,24,16.657,16.657,0,0,0,24,41Z",
    transform: "translate(-4 -4)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetization);
export default __webpack_public_path__ + "static/media/monetization.f6a02b48db54fda78e7ceef699f863fd.svg";
export { ForwardRef as ReactComponent };